import { configureRequest, replacePathVariables } from '../../../../networkRequests/apiClient/apiClient.functions'
import urls from '../../../../networkRequests/apiClient/endpoints'
import { getUserRoleForBackend } from '../../../../shared/functions/UserRole/userRoleManagment.functions'
import {
  AcceptFulfillmentOrderErrorResponse,
  AcceptFulfillmentOrderRequest,
  AcceptFulfillmentOrderSuccessResponse
} from './acceptFulfillmentOrder.types'

export const acceptFulfillmentOrderApi = async (
  request: AcceptFulfillmentOrderRequest
): Promise<AcceptFulfillmentOrderSuccessResponse> => {
  const response = await configureRequest({
    url: replacePathVariables(urls.fulfillmentOrders.accept, { orderId: request.orderId }),
    method: 'POST',
    headers: {
      'X-User-Role': getUserRoleForBackend()
    },
    data: {
      confirmationFlightItineraryId: request.confirmationFlightItineraryId,
      stayZipCode: request.stayZipCode,
      dropoffLocationId: request.dropoffLocationId,
      applyToAllOrdersOnFlight: request.applyToAllOrdersOnFlight
    }
  })

  if (response.status >= 200 && response.status < 300) {
    return response as AcceptFulfillmentOrderSuccessResponse
  } else {
    throw response as AcceptFulfillmentOrderErrorResponse
  }
}

export default acceptFulfillmentOrderApi
